/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiSyncStatus;
(function (ApiSyncStatus) {
    ApiSyncStatus["UNSPECIFIED"] = "SYNC_STATUS_UNSPECIFIED";
    ApiSyncStatus["ERROR"] = "SYNC_STATUS_ERROR";
    ApiSyncStatus["PENDING"] = "SYNC_STATUS_PENDING";
})(ApiSyncStatus || (ApiSyncStatus = {}));
export function ApiSyncStatusFromJSON(json) {
    return ApiSyncStatusFromJSONTyped(json, false);
}
export function ApiSyncStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiSyncStatusToJSON(value) {
    return value;
}
